// extracted by mini-css-extract-plugin
export var content = "_ol-1";
export var fullScreen = "_ol-0";